'use strict';

angular.module('TurneroApp').service('loginService', ['$resource', 'portal', function ($resource, portal) {
	return $resource(portal.getUrlServer() + 'api/Login/:id', { id: '@Id' }, {
        Login:{
            method: 'GET',
            manejarErrorIngreso: true,
            params: {
                usuario: '@usuario',
                clave: '@clave'
            },
            url: portal.getUrlServer() + 'api/Login'
        },
        setSesionId:{
            method: 'POST',
            manejarErrorIngreso: true,
            params: {
                sesionid: '@sesionid',
                tokenVeDi: '@tokenVeDi'
            },
            url: portal.getUrlServer() + 'api/Login'
        },
        Post_Usuario_VeDi:{
            method: 'POST',
            manejarErrorIngreso: true,
            url: portal.getUrlServer() + 'api/Login/Post_Usuario_VeDi/'
        }
	});
}]);



// WEBPACK FOOTER //
// ./app/components/login/loginService.js